import { render, staticRenderFns } from "./Rodape.vue?vue&type=template&id=069e12c0&scoped=true&"
import script from "./Rodape.vue?vue&type=script&lang=js&"
export * from "./Rodape.vue?vue&type=script&lang=js&"
import style0 from "./Rodape.vue?vue&type=style&index=0&id=069e12c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069e12c0",
  null
  
)

export default component.exports